import { useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms';
import { SECTION_TYPES } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useCategory } from '../useCategory';
import { useGamesData } from '../useGamesData';
import { useGetIsWagerSlotGamesLoaded } from '../useGetIsWagerSlotGamesLoaded';
import { useGetWagerSlotsGamesIds } from '../useGetWagerSlotsGamesIds';

export const useWagerSlotsGamesCategory = (
  feedName: string,
  showWagerSlotsCategory: boolean,
  casinoType: CasinoTypeUnion
) => {
  const gamesData = useGamesData();

  const { casinoDynamicCategoriesIds = {} } = useOtherSettings();
  const isWagerSlotGamesLoaded = useGetIsWagerSlotGamesLoaded();
  const feedWagerCategory = useCategory(
    casinoDynamicCategoriesIds?.wagerSlots,
    feedName,
    casinoType
  );

  const wagerSlotGamesIds = useGetWagerSlotsGamesIds(feedName);

  const actualWagerSlotGames = useMemo(
    () => wagerSlotGamesIds.map((gameId) => gamesData[gameId]),
    [gamesData, wagerSlotGamesIds]
  );

  const preparedWagerSlotsCategory = useMemo(
    () => ({
      ...(feedWagerCategory ?? {}),
      type: SECTION_TYPES.CATEGORY_GENERAL,
      categoryGames: actualWagerSlotGames,
      games: wagerSlotGamesIds
    }),
    [feedWagerCategory, actualWagerSlotGames, wagerSlotGamesIds]
  );

  if (
    !casinoDynamicCategoriesIds?.wagerSlots ||
    !showWagerSlotsCategory ||
    isEmpty(feedWagerCategory) ||
    (isWagerSlotGamesLoaded && isEmpty(actualWagerSlotGames))
  ) {
    return null;
  }

  return preparedWagerSlotsCategory;
};
